"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateType = exports.validateSize = exports.default = void 0;
var _i18n = require("@wordpress/i18n");
var _validationFactory = _interopRequireDefault(require("./validationFactory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// External

// Internal

const MIN_WIDTH = 200;
const MIN_HEIGHT = 200;

/**
 * Checks if the image dimensions are allowed. If not correct returns a warning.
 *
 * @param {Object} image The image type.
 *
 * @returns {string | boolean} A warning string | true.
 */
const validateSize = image => {
  const {
    width,
    height
  } = image;
  const warningMessage = (0, _i18n.sprintf)( /* Translators: %d expands to the minimum width, %d expands to the minimum hight */
  (0, _i18n.__)("Your image dimensions are not suitable. The minimum dimensions are %dx%d pixels.", "wordpress-seo"), MIN_WIDTH, MIN_HEIGHT);
  return width < MIN_WIDTH || height < MIN_HEIGHT ? warningMessage : true;
};

/**
 * Checks if the image type is allowed. If not correct returns a warning.
 *
 * @param {string} image The image type.
 *
 * @returns {string | boolean} A warning string | true.
 */
exports.validateSize = validateSize;
const validateType = image => {
  const {
    type
  } = image;
  const validTypes = ["jpg", "png", "gif", "jpeg", "webp"];
  const warningMessage = (0, _i18n.sprintf)( /* Translators: %s expands to the jpg format, %s expands to the png format, %s expands to the gif format. */
  (0, _i18n.__)("The format of the uploaded image is not supported. The supported formats are: %s, %s, %s and %s.", "wordpress-seo"), "JPG", "PNG", "WEBP", "GIF");
  if (!validTypes.includes(type)) {
    return warningMessage;
  }
  return true;
};
exports.validateType = validateType;
const validate = (0, _validationFactory.default)([validateSize, validateType]);
var _default = exports.default = validate;